// import React from "react";
import * as types from '../../../constants/ComponentConstants';
// import mergeDeep from "../../util/mergeDeep";
// import L from 'leaflet';
// import ReactDOMServer from 'react-dom/server';
// import { showToastrWarning } from "../../util/toastr";

export default class MapComponentHelper {

    constructor(context) {
        this.context = context;
        this.polygonenWfst = null;
        this.infrastructurenWfst = null;

        this.onMoveEnd = this.onMoveEnd.bind(this);
        this.onMarkerDragEnd = this.onMarkerDragEnd.bind(this);
        this._handleError = this._handleError.bind(this);
    }

    onMoveEnd(e) {
        // if (this.context.state.loadPolygonenAfterNextMove) {
        //     this.context.setState({ loadPolygonenAfterNextMove: false });
        //     this._loadPolygonen(e.target);
        // }
    }

    // onPolygonDrawStart = (e) => {
    //     this.context.setState({ creatingPolygon: true });
    //     this.context.map.leafletElement.pm.enableDraw('Polygon', MapConfig.DrawOptions);
    // }

    // onPolygonEditStop = (e) => {
    //     this.context.map.leafletElement.eachLayer(l => {
    //         if (l._leaflet_id === this.context.state.editingPolygoonLeafletId) {
    //             l.remove();
    //         }
    //     });

    //     this._resetEditingPolygoon(() => this._loadPolygonen(this.context.map.leafletElement, true));
    // }

    // onPolygonDrawStop = (e) => {
    //     this.context.map.leafletElement.pm.disableDraw('Polygon');

    //     if (this.context.state.creatingPolygon && this.context.state.editingPolygoonLeafletId)
    //         this.context.map.leafletElement.eachLayer(l => {
    //             if (this.context.state.editingPolygoonLeafletId === l._leaflet_id)
    //                 this.context.map.leafletElement.removeLayer(l);
    //         });

    //     this._resetEditingPolygoon();
    // }

    // onPolygonEdited = (e) => {
    //     const polygonenWfst = this.polygonenWfst;
    //     const editingPolygoonLeafletId = this.context.state.editingPolygoonLeafletId;
    //     const editingPolygoonNaam = this.context.state.editingPolygoonNaam;

    //     let editedLayer;

    //     this.context.map.leafletElement.eachLayer(layer => {
    //         if (layer._leaflet_id === editingPolygoonLeafletId) {
    //             editedLayer = layer;
    //         }
    //     });

    //     editedLayer.pm.toggleEdit();
    //     editedLayer.feature.properties['Naam'] = editingPolygoonNaam;
    //     polygonenWfst.editLayer(editedLayer);

    //     this._addEditPolygoonWfstEventsHandlers(this.context.state.editingPolygoonFeatureId.split('.')[1]);
    // }

    // onPolygonCreated = (e) => {
    //     const polygonenWfst = this.polygonenWfst;
    //     const editingPolygoonLeafletId = this.context.state.editingPolygoonLeafletId;
    //     const editingPolygoonNaam = this.context.state.editingPolygoonNaam;

    //     let editedLayer;

    //     this.context.map.leafletElement.eachLayer(layer => {
    //         if (layer._leaflet_id === editingPolygoonLeafletId) {
    //             editedLayer = layer;
    //         }
    //     });

    //     editedLayer.pm.toggleEdit();
    //     editedLayer.feature = {
    //         properties: {
    //             'Naam': editingPolygoonNaam
    //         }
    //     };
    //     polygonenWfst.addLayer(editedLayer);

    //     this._addEditPolygoonWfstEventsHandlers();
    // }

    // onPolygonDeleteClick(confirmed) {
    //     this.context.setState({ showPolygonDeleteConfirm: false });

    //     if (confirmed)
    //         this.onPolygonDeleted();
    // }

    // onPolygonDeleted = () => {
    //     const polygonenWfst = this.polygonenWfst;
    //     const editingPolygoonLeafletId = this.context.state.editingPolygoonLeafletId;

    //     this.context.map.leafletElement.eachLayer(layer => {
    //         if (layer._leaflet_id === editingPolygoonLeafletId) {
    //             polygoonApi.doPolygoonRemovalUpdates(this.context.state.editingPolygoonFeatureId.split('.')[1])
    //                 .then((response) => {
    //                     polygonenWfst.removeLayer(layer);
    //                     polygonenWfst._events.load = [];
    //                     polygonenWfst._events.error = [];
    //                     this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });

    //                     polygonenWfst.on('load', e => {
    //                         this._resetEditingPolygoon();
    //                         this.context.setState({ loadingCounter: this.context.state.loadingCounter - 1 });
    //                     });

    //                     polygonenWfst.on('error', this._handleError);
    //                     polygonenWfst.save();
    //                 }).catch(this._handleError);
    //         }
    //     });
    // }

    onMarkerDragEnd(e, sisId) {
        const newMarker = Object.assign(this.context.state.markers.find(m => m.sisId === sisId),
            {
                lat: e.target.getLatLng().lat,
                long: e.target.getLatLng().lng,
                newLatLng: e.target.getLatLng(),
                color: types.COLOR_GREEN, edited: true
            });

        const newMarkers = [...this.context.state.markers.filter(m => m.sisId !== sisId), newMarker];
        this.context.setState({
            editingMarkers: true,
            markers: newMarkers,
            markersToShow: this.context.mapHelper.convertToMarkersToShow(newMarkers)
        });
    }

    // onMarkerSave = () => {
    //     const updatedInfrastructuren = this.context.state.markers.filter(m => m.newLatLng);

    //     updatedInfrastructuren.forEach(um => {
    //         let infraToUpdate = this.infrastructurenWfst._layers[um.leafletId];
    //         infraToUpdate.setLatLng(um.newLatLng);
    //         this.infrastructurenWfst.editLayer(infraToUpdate);
    //     });

    //     this.infrastructurenWfst._events.load = [];
    //     this.infrastructurenWfst._events.error = [];
    //     this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });

    //     this.infrastructurenWfst.on('load', e => {
    //         let promises = [];
    //         this.context.setState({ loadingCounter: this.context.state.loadingCounter - 1 });
    //         updatedInfrastructuren.forEach(i => {
    //             this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });
    //             promises.push(infrastructuurApi.doInfrastructuurUpdates(i.feature.id.split('.')[1])
    //                 .then((response) => {
    //                     this.context.setState({ loadingCounter: this.context.state.loadingCounter - 1 });
    //                 }).catch(this._handleError));
    //         });

    //         Promise.all(promises).then(() => { //show
    //             this.context.setState({
    //                 editingMarkers: false,
    //                 mapBoundsBeforeSave: this.context.map.leafletElement.getBounds()
    //             }, () => this.onSearch(true));
    //         });
    //     });

    //     this.infrastructurenWfst.on('error', this._handleError);

    //     this.infrastructurenWfst.save();
    // }

    // onMarkerCancel = () => {
    //     this.context.setState({
    //         markers: this.context.state.originalMarkers.map(m => mergeDeep({}, m)),
    //         markersToShow: this.context.mapHelper.convertToMarkersToShow(this.context.state.originalMarkers),
    //         editingMarkers: false
    //     });
    // }

    // _createInfrastructuurWfstFilter = (filterIds) => {
    //     let filter = false;

    //     if ((!filterIds || !(filterIds.length > -1))) {
    //         if (this.context.map.leafletElement._zoom > 11)
    //             filter = new L.Filter.BBox('Geometry', this.context.map.leafletElement.getBounds(), L.CRS.EPSG4326);
    //         else {
    //             showToastrWarning(`Opgelet: Het gebied is te groot om zonder filters te zoeken. Probeer in te zoomen of gebruik filters om het aantal resultaten te verminderen.`);
    //             return false;
    //         }
    //     }
    //     else {
    //         filter = new L.Filter.Or(...((filterIds.length > this.context.props.maxMapFeaturesToLoad) ? filterIds.slice(0, this.context.props.maxMapFeaturesToLoad - 1) : filterIds).map(id => new L.Filter.Like('SisID', id)));
    //         if (filterIds.length > this.context.props.maxMapFeaturesToLoad) {
    //             showToastrWarning(`Opgelet: Er werden teveel infrastructuren gevonden (${filterIds.length}). Probeer nauwkeuriger te filteren om het aantal resultaten te verminderen.`);
    //             return false;
    //         }
    //     }

    //     return filter;
    // }

    // _handlePolygoonClick(e) {
    //     if (!this.context.state.creatingPolygon && !this.context.state.editingPolygon && !this.context.state.editingMarkers) {
    //         this.context.setState({
    //             editingPolygon: true,
    //             editingPolygoonLeafletId: e.target._leaflet_id,
    //             editingPolygoonFeatureId: e.target.feature.id,
    //             editingPolygoonFeature: e.target.feature,
    //             editingPolygoonNaam: e.target.feature.properties['Naam']
    //         });
    //         e.target.setStyle({ color: 'orange' });
    //         e.target.pm.toggleEdit(MapConfig.DrawOptions);
    //     }
    // }

    // _handleNewPolygoonLayer = (newLayer) => {
    //     //attach click handler
    //     newLayer.on('click', (e) => {
    //         this._handlePolygoonClick(e);
    //     });

    //     //attach tooltip
    //     const tooltipContent = <PolygoonTooltip
    //         naam={newLayer.feature.properties['Naam']}
    //         gemeente={newLayer.feature.properties['Gemeente']}
    //         infraAmount={newLayer.feature.properties['LocatiesGeplaatst'] || 0}
    //     />;

    //     newLayer.bindTooltip(ReactDOMServer.renderToString(tooltipContent)); //show
    //     return { id: newLayer._leaflet_id, featureId: newLayer.feature.id };
    // }

    // onSearch = () => {
    //     // this._loadMarkersByWfst(...);
    // }

    // _loadMarkersByWfst = (filterIds, keepBounds, emptyFilter) => {
    //     const context = this.context;

    //     const filter = this._createInfrastructuurWfstFilter(filterIds);

    //     if (!filter)
    //         return;

    //     let infrastructurenWfstOptions = {
    //         url: `${context.props.geoToogeoToolboxUrllBoxUrl}geospakki/wfs`,
    //         typeNS: 'geospakki',
    //         typeName: 'Sportinfrastructuur',
    //         geometryField: 'Geometry',
    //         filter: filter,
    //         crs: L.CRS.EPSG4326,
    //         maxFeatures: context.props.maxMapFeaturesToLoad
    //     };

    //     this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });
    //     this.infrastructurenWfst = new L.WFST(infrastructurenWfstOptions)
    //         .on('load', e => {
    //             if (!e.layers || (e.layers && !e.layers.length))
    //                 showToastrWarning('Geen infrastructuren gevonden die aan de filters voldoen');

    //             const markers = e.layers.map(l => {
    //                 return {
    //                     sportInfrastructuurID: l.feature.properties['SportInfrastructuurID'],
    //                     sisId: l.feature.properties['SisID'],
    //                     naam: l.feature.properties['Naam'],
    //                     gemeente: l.feature.properties['Gemeente'],
    //                     lat: l.getLatLng().lat.toString(),
    //                     long: l.getLatLng().lng.toString(),
    //                     feature: l.feature,
    //                     color: l.feature.properties['PolygoonID'] && l.feature.properties['PolygoonID'] > 0 ? types.COLOR_GREEN : types.COLOR_RED,
    //                     type: l.feature.properties['PolygoonID'] && l.feature.properties['PolygoonID'] > 0 ? "De Infrastructuur werd al verplaatst" : "De Infrastructuur is nieuw en werd nog niet verplaatst",
    //                     leafletId: l._leaflet_id
    //                 };
    //             });

    //             this.context.setState({
    //                 markers: markers.map(m => mergeDeep({}, m)),
    //                 originalMarkers: markers.map(m => mergeDeep({}, m)),
    //                 markersToShow: this.context.mapHelper.convertToMarkersToShow(markers),
    //                 lockBounds: keepBounds ? true : false,
    //                 loadingCounter: this.context.state.loadingCounter - 1,
    //                 loadPolygonenAfterNextMove: !keepBounds
    //             });

    //             if (keepBounds)
    //                 this._loadPolygonen(this.context.map.leafletElement, true, emptyFilter);
    //         });

    //     this.infrastructurenWfst.on('error', this._handleError);
    // }

    // _loadPolygonen(map, useLastMapBounds, emptyFilter) {
    //     this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });

    //     const bounds = useLastMapBounds && this.context.state.lastMapBounds && !emptyFilter ? this.context.state.lastMapBounds : map.getBounds();

    //     if (!useLastMapBounds)
    //         this.context.setState({ lastMapBounds: map.getBounds() });

    //     const polygonenWfstOptions = {
    //         url: `${this.context.props.geoToolboxUrl}geospakki/wfs`,
    //         typeNS: 'geospakki',
    //         typeName: 'Polygoon',
    //         geometryField: 'Geometry',
    //         filter: new L.Filter.BBox('Geometry', bounds, L.CRS.EPSG4326),
    //         crs: L.CRS.EPSG4326,
    //         opacity: 1,
    //         fillOpacity: 0,
    //         style: {
    //             color: 'blue',
    //             zIndex: 1000
    //         }
    //     };

    //     const editingPolygoonFeatureId = this.context.state.editingPolygoonFeatureId;

    //     this.polygonenWfst = new L.WFST(polygonenWfstOptions);
    //     this.polygonenWfst.addTo(map)
    //         .on('load', (e) => {
    //             this._fillPolygonenDropdown(e.layers);

    //             let newLayerData = [];

    //             this.polygonenWfst.eachLayer(newLayer => {
    //                 if (editingPolygoonFeatureId && newLayer.feature.id === editingPolygoonFeatureId)
    //                     newLayer.remove();
    //                 else {
    //                     newLayerData.push(this._handleNewPolygoonLayer(newLayer));
    //                 }
    //             });

    //             this._removeOldPolygoonLayers(newLayerData);
    //             this.context.setState({ loadingCounter: this.context.state.loadingCounter - 1 });
    //         });

    //     this.polygonenWfst.on('error', this._handleError);
    // }

    // _addEditPolygoonWfstEventsHandlers(polygoonFeatureId) {
    //     const polygonenWfst = this.polygonenWfst;
    //     polygonenWfst._events.load = [];
    //     polygonenWfst._events.error = [];
    //     polygonenWfst.on('error', this._handleError);

    //     polygonenWfst.on('load', e => {
    //         const isNew = !polygoonFeatureId;
    //         polygoonApi.doPolygoonUpdates(polygoonFeatureId || e.layers[0].feature.id.split('.')[1], isNew)
    //             .then((response) => {
    //                 this._resetEditingPolygoon(() => {
    //                     this.onSearch(true);
    //                 });
    //                 this.context.setState({ loadingCounter: this.context.state.loadingCounter - 1 });
    //             }).catch(this._handleError);
    //     });

    //     this.context.setState({ loadingCounter: this.context.state.loadingCounter + 1 });
    //     polygonenWfst.save();
    // }

    // _removeOldPolygoonLayers(newLayers) { //show
    //     const editingPolygoonFeatureId = this.context.state.editingPolygoonFeatureId;
    //     const editingPolygoonLeafletId = this.context.state.editingPolygoonLeafletId;

    //     this.context.map.leafletElement.eachLayer(l => {
    //         if (l.feature && l.feature.id && l.feature.id.includes('Polygoon'))
    //             if (newLayers.some(ltc => ltc.featureId === l.feature.id && ltc.id !== l._leaflet_id) || (l.feature.id === editingPolygoonFeatureId)) {
    //                 if (l._leaflet_id != editingPolygoonLeafletId)
    //                     l.remove();
    //             }
    //             else if (!newLayers.some(nl => nl.featureId === l.feature.id) && l.feature.id !== editingPolygoonFeatureId)
    //                 l.remove();
    //     });
    // }

    // _resetEditingPolygoon = (callbackFn) => {
    //     this.context.setState({
    //         creatingPolygon: false,
    //         editingPolygon: false,
    //         editingPolygoonLeafletId: null,
    //         editingPolygoonFeatureId: null
    //     }, callbackFn);
    // }

    _handleError(e) {
        this.context.setState({
            loadingCounter: this.context.state.loadingCounter - 1,
            failedCalls: this.context.state.failedCalls + 1
        });
        this.context.props.throwException(e, true);
    }
}